import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { RequestsService } from "../../../services/requests.service";
import { NewRequestService } from "../../../models/request/new-request/new-request-service";
import { RequestServicesService } from "../../../services/request-services.service";
import { CategoryServicesService } from "../../../services/category-services.service";
import { KeyValueObject } from "../../../models/core/KeyValueObject";
import { DropDownFilterSettings } from "@progress/kendo-angular-dropdowns";
import { NewRequestDevice } from "../../../models/request/new-request/new-request-device";
import { RequestDevicesService } from "../../../services/request-devices.service";
import { ReserveResult } from "../../../enums/reserve-result.enum";
import { UploadAttachmentsModel, UploadFile } from "../../../models/attachment";
import { AttachmentsService } from "../../../services/attachments.service";
import { RequestType } from "../../../enums";
import { LookupService } from "../../../services/lookup.service";
import { DeviceModelsService } from "../../../services/device-models.service";
import { forkJoin } from "rxjs";
import { DeviceModelDto } from "../../../models/device/device-model-dto";
import { SecurityService } from "../../../../core/services/security.service";
import { NotificationService } from "../../../../core/services/notification.service";
import { DeviceTypesService } from "../../../services/device-types.service";
import { DeviceTypeDto } from "../../../models/device/device-type.dto";
import { NotificationType } from "../../../../core/services/notification-type";
import { ServiceItem } from "../../../models/services/service-item";

@Component({
	selector: 'finish-activity-with-devices-services',
	templateUrl: './finish-activity-with-devices-services.html',
	styleUrls: ['./finish-activity-with-devices-services.scss',
		'../../../../../vendor/libs/angular2-ladda/angular2-ladda.scss',
		'../../../../../vendor/libs/ngx-perfect-scrollbar/ngx-perfect-scrollbar.scss',
	]
})
export class FinishActivityWithDevicesServices implements OnInit {
    
    @Input() requestId: number;
    @Input() requestTypeId: number;
    @Input() claimId: number;
    @Input() resolution: string;
    @Input() activityId: number;

    @Output() onContinueEvent: EventEmitter<any> = new EventEmitter();
    @Output() onCancelEvent: EventEmitter<any> = new EventEmitter();

    deviceTypeFullItems: DeviceTypeDto[] = [];
    deviceTypes: KeyValueObject[] = [];
    deviceModels: DeviceModelDto[] = [];
    dropDownDeviceModels: DeviceModelDto[] = [];
    deviceSuppliers: DeviceModelDto[] = [];
    dropDownDeviceSuppliers: DeviceModelDto[] = [];
    marketPlaces: KeyValueObject[] = [];
    services: KeyValueObject[] = [];
    fullService: ServiceItem[] = [];

    attachments: UploadFile[] = [];
    requestServices: NewRequestService[] = [];
    requestDevices: NewRequestDevice[] = [];
    reclamationRequestDevices: NewRequestDevice[] = [];
    problems: KeyValueObject[] = [];

    filesUploaded: boolean = false;
    dataSaving: boolean = false;
    loadingServices: boolean = false;
    loadingDevices: boolean = false;

    roleForceDiscount: boolean;
    roleDiscountLimit: number;
    deviceMaxDiscountLimit: number;
    serviceMaxDiscountLimit: number;

    dropDownFilterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'contains' };

    constructor(
        private requestsService: RequestsService,
        private deviceTypesService: DeviceTypesService,
        private requestServicesService: RequestServicesService,
        private requestDevicesService: RequestDevicesService,
        private attachmentsService: AttachmentsService,
        private lookupService: LookupService,
        private deviceModelsService: DeviceModelsService,
        private categoryServicesService: CategoryServicesService,
        private securityService: SecurityService,
        private notificationService: NotificationService
    ) { }

    ngOnInit(): void {
        this.roleDiscountLimit = this.securityService.currentUser.discountLimit;
        this.roleForceDiscount = this.securityService.currentUser.forceDiscount;

        this.loadRequestServices();
        this.loadRequestDevices();
        this.loadRequestProblems();
        this.initLookups();
    }

    loadRequestServices() {
        this.loadingServices = true;
        this.requestsService.getRequestServices(this.requestId).subscribe(resp => {
            this.requestServices = resp;
            this.loadingServices = false;

            this.requestServices.filter(requestService => requestService.isDone != true).forEach(requestService => {
                requestService.isDone = true;
                this.saveRequestServiceHandler({ requestService });
            });
        });
    }

    loadRequestDevices() {
        this.loadingDevices = true;

        this.requestsService.getRequestDevices(this.requestId)
            .subscribe(requestDevices => {
                if (this.isReclamation) {
                    this.requestDevices = requestDevices.filter(x => 
                        x.reserveResultId != ReserveResult.installedOnTsp || !x.inCustomerObject);
                    this.reclamationRequestDevices = requestDevices.filter(x => 
                        x.reserveResultId == ReserveResult.installedOnTsp && x.inCustomerObject);
                }
                else {
                    this.requestDevices = requestDevices;            
                }
    
                this.requestDevices.forEach(x => {
                    x.toDelivery = x.reserveResultId == ReserveResult.installedOnTsp;
                });

                this.loadingDevices = false;
            });
    }

    loadRequestProblems() {
        this.requestsService.getRequestProblems(this.requestId).subscribe(resp => {
            this.problems = resp.data;
        });
    }

    initLookups() {
        const marketPlaces$ = this.lookupService.getData('device-market-places', null);
        const deviceTypes$ = this.deviceTypesService.getAllDeviceTypesNoCategory();
        const deviceModels$ = this.deviceModelsService.getAll(true);
        const services$ = this.categoryServicesService.list();

        forkJoin(deviceTypes$, deviceModels$, marketPlaces$, services$)
        .subscribe(([deviceTypes, deviceModels, marketPlaces, services]) => {
            this.deviceTypeFullItems = deviceTypes;
            this.deviceTypes = deviceTypes.map(x => new KeyValueObject(x.deviceTypeId, x.name));
            this.deviceModels = deviceModels;
            this.dropDownDeviceModels = [];
            this.deviceSuppliers = this.deviceModels.filter(x => x.parentId == null);
            this.dropDownDeviceSuppliers = [];
            this.marketPlaces = marketPlaces;

            this.fullService = services.data;
            this.services = services.data.map(x => new KeyValueObject(x.id, x.name));
        });
    }

    saveChanges() {
        this.dataSaving = true;
        this.filesUploaded = false;

        const uploadModel = new UploadAttachmentsModel({ 
            requestId: this.requestId,
            activityId: this.activityId,
            attachments: this.attachments 
        });

		this.attachmentsService.upload(uploadModel).subscribe(() => {
            if (!this.filesUploaded) {
                this.filesUploaded = true;
                if (this.isReclamation) {
                    this.requestsService.updateRequestProblemResolution(this.requestId, this.claimId, this.resolution).subscribe(() => {
                        this.onContinueEvent.emit();
                        this.dataSaving = false;
                    });
                }
                else {
                    this.onContinueEvent.emit();
                    this.dataSaving = false;                
                }
            }
        });
    }

    cancel() {
        this.onCancelEvent.emit();
    }

    // методы для оборудования

    saveRequestDeviceHandler({ dataItem }: any) {
        if (this.deviceDiscountInvalid(dataItem)) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.deviceMaxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
            return;
        }

        this.dataSaving = true;
        let requestDevice = <NewRequestDevice>dataItem;
        requestDevice.reserveResultId = requestDevice.toDelivery 
            ? <number>ReserveResult.installedOnTsp
            : <number>ReserveResult.equipmentReceivedByEngineer;

        this.requestDevicesService.update(requestDevice, null).subscribe(() => {
            this.dataSaving = false;
            this.loadRequestProblems();
            this.loadRequestDevices();
        });
    }

    turnRequestDevice(event: any, dataItem: NewRequestDevice) {
        dataItem.toDelivery = event.target.checked;
        this.saveRequestDeviceHandler({dataItem});
    }

    public editRequestDeviceHandler({ sender, rowIndex, dataItem }) {
        this.handleDeviceSuppliersDropdownOpen(dataItem.deviceTypeId);
        this.handleDeviceModelsDropdownOpen(dataItem.deviceSupplierId);
        this.calculateDeviceMaxDiscountLimit(dataItem);

		sender.editRow(rowIndex);
	}

    createNewRequestDevice(): NewRequestDevice {
        let device = new NewRequestDevice();
        device.manuallyAdded = true;
        device.requestId = this.requestId;
        return device;
    }

    public deviceTypeChange(deviceTypeId: number, requestDevice: NewRequestDevice = null) {
        if (requestDevice) {
            requestDevice.deviceModelId = null;
            requestDevice.deviceSupplierId = null;
        }

        this.calculateDeviceMaxDiscountLimit(requestDevice);
    }

    filterDeviceSupplierName(value: string, requestDevice: NewRequestDevice) {
        requestDevice.deviceSupplierId = null;
        requestDevice.deviceModelId = null;
        this.dropDownDeviceSuppliers = value == null || value.trim() == ''
            ? this.deviceSuppliers.filter(x => x.typeId == requestDevice.deviceTypeId)
            : this.deviceSuppliers.filter(x => 
                x.typeId == requestDevice.deviceTypeId && x.name.trim().toLowerCase().includes(value.trim().toLowerCase()));
    }

    changeValueDeviceSupplier(value: string, requestDevice: NewRequestDevice) {
        let selectedSupplier = this.deviceSuppliers.find(x => x.name == value);
        if (selectedSupplier != null) {
            requestDevice.deviceSupplierId = selectedSupplier.id;
        }

        if (requestDevice.deviceSupplierId) {
            this.dropDownDeviceModels = this.deviceModels.filter(x => x.parentId === requestDevice.deviceSupplierId)
        }
    }

    filterDeviceModelName(value: string, requestDevice: NewRequestDevice) {
        requestDevice.deviceModelId = null;
        this.dropDownDeviceModels = value == null || value.trim() == '' 
            ? requestDevice.deviceSupplierId 
                ? this.deviceModels.filter(x => x.parentId == requestDevice.deviceSupplierId)
                : []
            : this.deviceModels.filter(x => 
                x.parentId == requestDevice.deviceSupplierId && x.name.trim().toLowerCase().includes(value.trim().toLowerCase()));
        }

    changeValueDeviceModel(value: string, requestDevice: NewRequestDevice) {
        let selectedModel = this.deviceModels.find(x => x.name == value);
        if (selectedModel != null) {
            requestDevice.deviceModelId = selectedModel.id;
        }
    }

    public handleDeviceSuppliersDropdownOpen(deviceTypeId: number) {
        this.dropDownDeviceSuppliers = this.deviceModels != null && deviceTypeId
            ? this.deviceSuppliers.filter(x => x.typeId == deviceTypeId)
            : [];
    }

    public handleDeviceModelsDropdownOpen(deviceSupplierId: number) {
		this.dropDownDeviceModels = this.deviceModels != null && deviceSupplierId
            ? this.deviceModels.filter(x => x.parentId === deviceSupplierId)
            : [];
	}

    canSaveRequestDevice(requestDevice: NewRequestDevice): boolean {
        let discountValid = !this.deviceDiscountInvalid(requestDevice);

        return requestDevice.customerDevice == false ||
            (requestDevice.customerDevice == true &&
            requestDevice.deviceTypeId && 
            (requestDevice.deviceSupplierId || (requestDevice.deviceSupplierName && requestDevice.deviceSupplierName.trim() != '')) && 
            (requestDevice.deviceModelId || (requestDevice.deviceModelName && requestDevice.deviceModelName.trim() != '')) && 
            discountValid &&
            requestDevice.serialNumber && requestDevice.serialNumber.trim() != '');
    }

    calculateDeviceMaxDiscountLimit(requestDevice: NewRequestDevice) {
        if (this.roleForceDiscount) {
            this.deviceMaxDiscountLimit = 100;
        }
        else if (requestDevice.deviceTypeId != null) {
            let deviceTypeDiscountLimit = this.deviceTypeFullItems.find(x => x.deviceTypeId == requestDevice.deviceTypeId).discountLimit;
            this.deviceMaxDiscountLimit = this.roleDiscountLimit > deviceTypeDiscountLimit
                ? deviceTypeDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.deviceMaxDiscountLimit = 0; 
        }
    }

    getDeviceCostWithDiscount(requestDevice: NewRequestDevice): number {
        if (requestDevice.fullCost && requestDevice.discount) {
            let cost = requestDevice.fullCost - (requestDevice.fullCost * requestDevice.discount / 100);
            return Number.isInteger(cost) ? cost : parseFloat(cost.toFixed(2));
        }

        return requestDevice.fullCost;
    }

    deviceDiscountChange(requestDevice: NewRequestDevice) {
        if (this.deviceDiscountInvalid(requestDevice) && requestDevice.discount > 0) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.deviceMaxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
        }
    }

    deviceDiscountInvalid(requestDevice: NewRequestDevice): boolean {
        return requestDevice.discount != null &&
            (requestDevice.discount < 0 || 
            requestDevice.discount > 100 ||
            requestDevice.discount > this.deviceMaxDiscountLimit);
    }

    // методы для услуг

    saveRequestServiceHandler({ dataItem }: any) {
        if (this.serviceDiscountInvalid(dataItem)) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.serviceMaxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
            return;
        }

        this.dataSaving = true;
        this.requestServicesService.update(dataItem, null).subscribe(() => {
            this.dataSaving = false;
            this.loadRequestServices();
        })
    }

    turnRequestService(event: any, dataItem: NewRequestService) {
        dataItem.isDone = event.target.checked;
        this.saveRequestServiceHandler({dataItem});
    }

    serviceChange(dataItem: NewRequestService) {
        this.calculateServiceMaxDiscountLimit(dataItem);
    }

    editRequestServiceHandler({ dataItem, rowIndex, sender }: any) {
        this.calculateServiceMaxDiscountLimit(dataItem);
        sender.editRow(rowIndex);
    }

    calculateServiceMaxDiscountLimit(requestService: NewRequestService) {
        if (this.roleForceDiscount) {
            this.serviceMaxDiscountLimit = 100;
        }
        else if (requestService.serviceId != null) {
            let serviceDiscountLimit = this.fullService.find(x => x.id == requestService.serviceId).discountLimit;
            this.serviceMaxDiscountLimit = this.roleDiscountLimit > serviceDiscountLimit
                ? serviceDiscountLimit
                : this.roleDiscountLimit;
        }
        else {
            this.serviceMaxDiscountLimit = 0; 
        }
    }

    getServiceCostWithDiscount(requestService: NewRequestService): number {
        if (requestService.fullCost && requestService.discount) {
            let cost = requestService.fullCost - (requestService.fullCost * requestService.discount / 100);
            return Number.isInteger(cost) ? cost : parseFloat(cost.toFixed(2));
        }

        return requestService.fullCost;
    }

    serviceDiscountChange(requestService: NewRequestService) {
        if (this.serviceDiscountInvalid(requestService) && requestService.discount > 0) {
            this.notificationService.error({
                title: `Вы превысили максимальный размер скидки - ${this.serviceMaxDiscountLimit}%`,
                notificationType: NotificationType.Toast,
                message: ''
            });
        }
    }

    serviceDiscountInvalid(requestService: NewRequestService): boolean {
        return requestService.discount != null &&
            (requestService.discount < 0 || 
            requestService.discount > 100 ||
            requestService.discount > this.serviceMaxDiscountLimit);
    }

    // Другие общие методы

    onAttachmentsAdded(attachments: UploadFile[]) {
		this.attachments = attachments;
	}

    getNameById(items: KeyValueObject[] = [], id: number): string {
        return items.some(x => x.id == id)
            ? items.find(x => x.id == id).name
            : '';
    }

    createRequestService(): NewRequestService {
        var requestService = new NewRequestService();
        requestService.requestId = this.requestId;
        requestService.isDefault = false;
        return requestService;    
    }


    public rowClass() {
		return {
			'cursor-pointer': true
		};
	}

    get canSave(): boolean {
        let commomCompleted = !this.loadingServices && !this.loadingDevices && !this.dataSaving && this.attachments.length > 0;
        let reclamationCompleted = this.isReclamation 
            ? this.claimId && this.resolution && this.resolution.trim() != ''
            : true;

        return commomCompleted && reclamationCompleted;
    }

    get isReclamation(): boolean {
        return this.requestTypeId == <number>RequestType.reclamation;
    }

    get hasDiscountRight(): boolean {
        return this.securityService.hasClaim('role-Discounting-right');
    }

    get isAdmin(): boolean {
        return this.securityService.isAdmin();
    }
}